module.exports = __webpack_public_path__ + "assets/img/user-8.aa9621fa.jpg";